import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import match from "./modules/match";
import getters from "./getters";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

// [新增] 封装一个带有过期时间的本地存储引擎 (模拟 Cookie 的 60MIN 过期机制)
const expStorage = {
  setItem: (key, value) => {
    // value 是 vuex-persistedstate 序列化后的 state 字符串
    const data = {
      state: value,
      expire: Date.now() + 60 * 60 * 1000, // 设定有效期为当前时间 + 60分钟 (精确到毫秒)
    };
    window.localStorage.setItem(key, JSON.stringify(data));
  },
  getItem: (key) => {
    const dataStr = window.localStorage.getItem(key);
    if (!dataStr) return null;

    try {
      const data = JSON.parse(dataStr);
      // [核心判断] 如果当前时间大于存储的过期时间，说明已失效
      if (data.expire && Date.now() > data.expire) {
        window.localStorage.removeItem(key); // 自动销毁僵尸数据
        return null; // 返回 null 会让 Vuex 初始化为默认的空状态 (未登录状态)
      }
      // 如果没过期，原样返回状态给 Vuex
      return data.state;
    } catch (e) {
      return null;
    }
  },
  removeItem: (key) => {
    window.localStorage.removeItem(key);
  },
};

const store = new Vuex.Store({
  modules: {
    user,
    match,
  },
  getters,
  plugins: [
    createPersistedState({
      key: "kxwj_vuex_state",
      storage: expStorage,
    }),
  ],
});

export default store;
